/**
 * Org owner/admin member actions that go through the backend (not the client
 * Firebase SDK). Kept thin — one `apiRequest` per operation.
 */
import { apiRequest } from './api';

/**
 * Email a password-reset link to a member's own address. The caller (org
 * owner/admin) never sees the link — only the member can complete it — so this
 * is the safe, delegable form of password recovery.
 */
export const sendMemberPasswordResetLink = (orgId: string, userId: string) =>
  apiRequest<{ ok: boolean; sentTo: string }>(
    `/organizations/${orgId}/members/${userId}/password-reset-link`,
    { method: 'POST' },
    orgId,
  );

/**
 * Real per-member last-active, sourced from Firebase Auth server-side. `null`
 * means the member has no recorded sign-in. Keyed by userId.
 */
export const getMembersActivity = (orgId: string) =>
  apiRequest<{ activity: Record<string, { lastActiveAt: number | null }> }>(
    `/organizations/${orgId}/members/activity`,
    { method: 'GET' },
    orgId,
  );
